import { DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { NgxMaskDirective, provideEnvironmentNgxMask } from 'ngx-mask';
import { provideMonacoEditor } from 'ngx-monaco-editor-v2';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

import { COLORS } from '../../constants/colors.constants';

import { AppConfigService } from '../../services/app-config.service';
import { AppService } from '../../services/app.service';
import { MessageService as MessageServiceTemplate } from '../../components/messages/message.service';
import { SystemService } from '../../services/system.service';
import { CoreRoutes } from './core.routing';

export const coreConfig: ApplicationConfig = {
  providers: [
    provideEnvironmentNgxMask(),
    provideMonacoEditor({ baseUrl: './assets/monaco/min/vs' }),
    provideRouter(CoreRoutes),
    provideZoneChangeDetection({ eventCoalescing: true }),
    providePrimeNG({
      ripple: true,
      theme: {
        preset: definePreset(Aura, {
          semantic: {
            primary: COLORS.primary,
          },
        }),
        options: {
          // Force light mode regardless of OS/device preference.
          darkModeSelector: 'none',
        },
      },
    }),
    importProvidersFrom(
      BrowserModule,
      LoadingBarModule,
      LoadingBarHttpClientModule,
      LoadingBarRouterModule,
      NgxMaskDirective,
      AngularSvgIconModule.forRoot(),
    ),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    DatePipe,
    MessageService,
    ConfirmationService,
    AppService,
    SystemService,
    AppConfigService,
    MessageServiceTemplate,
  ],
};
